import './_DataFeedModal.scss';
import { Modal } from 'react-bootstrap';
import { IDataFeedModal } from '../types/IDataFeedModal';

const DataFeedModal = (props: IDataFeedModal) => {
  return (
    <Modal
      contentClassName="modal-content-datafeed"
      show={props.show}
      onHide={() => props.onClose()}
      centered
      data-testid="modal-content-datafeed"
    >
      <Modal.Header closeButton>
        <Modal.Title>{props.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{props.content}</Modal.Body>
    </Modal>
  );
};
export default DataFeedModal;
